export default "__VITE_ASSET__O6TGmb$m__"